import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Timestamp } from '@dto';
import { GenericOldService } from './generic-old.service';

@Injectable({ providedIn: 'root' })
export class SiteStatsService {
  apiUrl: string;

  constructor(private resourceService: GenericOldService<Timestamp[]>) {
    this.apiUrl = resourceService.apiLocation;
  }

  siteStat$(
    siteId: string,
    stat: string,
    dci: number,
    startDate: number,
    stopDate: number,
    expand = false,
  ): Observable<Timestamp[]> {
    let query = `sites/${siteId}/statistics/${stat}?dci=${dci}&expand=${expand}`;
    if (startDate) {
      const startDttm = new Date(startDate);
      query += `&start_dttm=${startDttm.toISOString()}`;
    }
    if (stopDate) {
      const endDttm = new Date(stopDate);
      query += `&end_dttm=${endDttm.toISOString()}`;
    }
    return this.resourceService.get(query);
  }
}
